export var MAX_RATING = 5;
export var ON_RATE_HANDLER = 'onRate';